<template>
    <div>
        <v-layout row align-center justify-space-between class="header report-header">
            <v-btn flat dark :to="'/bot/' + activeBot.code">
                <v-icon class="mr-1">mdi-arrow-left-bold-circle-outline</v-icon>
                back
            </v-btn>
            <div style="font-size: 20px" class="report-title">{{$t('ticketManagement')|capitalize}}</div>
            <div>
                <v-menu bottom offset-y>
                    <template v-slot:activator="{ on }">
                        <v-layout align-center v-on="on" style="cursor: pointer" class="report-bot-list">
                            <span>{{ activeBot ? activeBot.name : '' }}</span>
                            <v-icon color="#fff">mdi-chevron-down</v-icon>
                        </v-layout>
                    </template>
                    <div style="max-height: 352px; overflow: auto;">
                        <v-list>
                            <v-list-tile
                                    v-for="bot in botList"
                                    :key="bot.code"
                                    @click="changeBot(bot)"
                                    :class="activeBot.code === bot.code ? 'active' : ''"
                            >
                                <v-list-tile-title>{{bot.name}}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </div>
                </v-menu>
            </div>
        </v-layout>
        <v-container fluid grid-list-sm>
            <v-card class="pa-1">
                <v-layout class="d-none">
                    <v-flex xs4>
                        <v-select
                                v-model="supporter"
                                label="Supporter"
                                :items="supporterList"
                                disabled
                        />
                    </v-flex>
                    <v-flex xs4>
                        <v-select
                                v-model="channel"
                                label="Channel"
                                :items="channelList"
                                disabled
                        />
                    </v-flex>
                    <v-flex xs4>
                        <v-select
                                v-model="density"
                                label="Density"
                                :items="densityList"
                                disabled
                        />
                    </v-flex>
                    <v-spacer/>
                </v-layout>
                <v-layout class="report-filter" style="gap: 8px">
                    <v-flex xs3>
                      <v-text-field
                          v-model="keyword"
                          :label="$t('search')"
                          @change="getData"
                          placeholder="Sender/Ticket"
                      />
                    </v-flex>
                    <v-flex xs1>
                        <v-select
                                v-model="tktStatus"
                                :label="$t('status')"
                                @change="getData"
                                :items="tktStatusList"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <v-select
                                v-model="interval"
                                :label="$t('interval')"
                                :items="intervalList"
                        />
                    </v-flex>
                    <v-flex xs2>
                        <DatePicker
                                v-model="fromDate"
                                :label="$t('fromDate')"
                                :max="toDate"
                                :disabled="interval !== 'custom'"
                        />
                    </v-flex>
                    <v-flex xs2>
                        <DatePicker
                                v-model="toDate"
                                :label="$t('toDate')"
                                :min="fromDate"
                                :max="today"
                                :disabled="interval !== 'custom'"
                        />
                    </v-flex>
                    <v-btn color="primary" @click="getData" v-if="interval === 'custom'">{{ $t('getData') }}</v-btn>
                    <v-btn color="primary" @click="exportExcel" :disabled="is_lock_report">{{ $t('exportExcel') }}</v-btn>
                </v-layout>
            </v-card>
            <v-card class="my-3">
                <v-data-table
                        :items="dataTableSort"
                        :headers="headers"
                        :pagination.sync="pagination"
                        :total-items="total_reports"
                        :rows-per-page-items="rowsPerPageItems"
                >
                    <template v-slot:items="props">
                        <tr :active="props.selected" @click="props.selected = !props.selected">
                            <td v-for="header of headers" :key="header.value" :width="header.width">
                                <span v-if="header.value!=='action'" class="break-word">
                                    <span v-if="header.$value">{{header.$value(props.item)}}</span>
                                    <span v-else v-html="props.item[header.value]" v-linkified></span>
                                </span>
                                <span v-else>
                                    <!-- <v-btn depressed round small color="success" v-if="props.item['status']==='0'" dark @click="closeTicket(props.item, props.item.index)">Close Ticket</v-btn> -->
                                    <v-btn depressed round small color="primary" v-if="props.item['status']==='0'" dark @click="openFormChangeTicketStatus(props.item)">{{$t('classifyTicket')}}</v-btn>
                                    <v-btn depressed round small color="warning" v-if="props.item['status']==='4' && check_ticket_allow_to_close(props.item) === false" dark @click="retrySendRequestTicket(props.item)">{{$t('retry')}}</v-btn>

                                    <v-btn depressed round small color="danger" v-if="check_ticket_allow_to_close(props.item)" dark @click="closeTicket(props.item, props.item.index)">Close Ticket</v-btn>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
        </v-container>
        <div class="chat_view_loading" v-if="loadingDialog">
            <div class="loading_overlay"></div>
            <v-progress-circular indeterminate size="54" color="white"></v-progress-circular>
        </div>
        <v-dialog v-model="showDialogTicketChangeStatus" width="500" persistent no-click-animation class="confirm">
            <v-card>
            <div class="fti-dialog-header">
                <div class="ml-3">{{ $t('ticketClassification') }}</div>
                <v-spacer></v-spacer>
                <v-btn flat icon @click="closeTicketDialog">
                    <v-icon color="#fff">mdi-close</v-icon>
                </v-btn>
            </div>

            <v-card-text>
                <p class="my-4">{{$t('ticketClassificationTitle')}}</p>
                <v-row>
                    <v-col cols="12">
                        <v-checkbox v-model="ticketClassification" :label="$t('ticketClassificationReportTrue')" value="2" hide-details></v-checkbox>
                    </v-col>
                    <v-col cols="12">
                        <v-checkbox v-model="ticketClassification" :label="$t('ticketClassificationReportFalse')" value="1" hide-details></v-checkbox>
                    </v-col>
                </v-row>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click="closeTicketDialog" class="action-btn">
                    {{ $t('cancel') | capitalize }}
                </v-btn>
                <v-btn color="primary" :disabled="ticketClassification!=='1' && ticketClassification!=='2'" @click="submitChangeTicketStatus" class="action-btn">
                    {{ $t('confirm') | capitalize }}
                </v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import ReportService from '@/services/report.service'
import _ from 'lodash'
import moment from 'moment'
import DatePicker from '@/components/custom/DatePicker'
import BotService from '@/services/bot.service'
import {mapState} from "vuex";
import ActionTypes from "@/store/ActionTypes";
import StaffService from "@/services/staff.service";

export default {
        name: 'TicketManagement',
        components: {DatePicker},
        data() {
            return {
                tktStatus: '',
                fromDate: moment().subtract(6, 'day').format('YYYY-MM-DD'),
                toDate: moment().format('YYYY-MM-DD'),
                today: moment().format('YYYY-MM-DD'),
                // senderName: '',
                keyword: '',
                interval: '7days',
                density: 'daily',
                supporter: 'all',
                channel: 'all',
                activeBot: {},
                dataTable: [],
                total_reports: 0,
                is_lock_report: false,
                min: {},
                max: {},
                supporterList: [
                    {text: 'All', value: 'all'}
                ],
                channelList: [
                    {text: 'All', value: 'all'}
                ],
                densityList: [
                    {text: 'Daily', value: 'daily'},
                    {text: 'Weekly', value: 'weekly'},
                    {text: 'Monthly', value: 'monthly'}
                ],
                intervalList: [
                    {text: this.$t('last7days'), value: '7days'},
                    {text: this.$t('last30days'), value: '30days'},
                    {text: this.$t('custom'), value: 'custom'}
                ],
                tktStatusList: [
                    {text: this.$t('all'), value: ''},
                    {text: this.$t('ticketStatus.opening'), value: '0'},
                    {text: this.$t('ticketStatus.closed'), value: '1'},
                    {text: this.$t('ticketStatus.inProgress'), value: '2'},
                    {text: this.$t('ticketStatus.done'), value: '3'},
                    {text: this.$t('ticketStatus.waiting'), value: '4'}
                ],
                pagination: {

                },
                rowsPerPageItems: [10, 20, 50, 100],
                loadingDialog: false,
                botList: [],
                headers: [
                    {
                        text: 'No.',
                        value: 'index',
                        sortable: false,
                        width: '2%'
                    },
                    {
                        text: this.$t('senderName'),
                        value: 'sender_name',
                        sortable: false,
                        width: '10%'
                    },
                    {
                        text: this.$t('ticketTitle'),
                        value: 'title',
                        sortable: false,
                        width: '10%'
                    },
                    {
                        text: this.$t('supportRequest'),
                        value: 'support_request',
                        sortable: false,
                        width: '20%'
                    },
                    {
                        text: this.$t('createdAt'),
                        value: 'created_time',
                        $value: item => this.dateFormat(item.created_time),
                        sortable: false,
                        width: '8%'
                    },
                    {
                        text: this.$t('status'),
                        value: 'status',
                        $value: item => this.genTicketStatusText(item.status),
                        sortable: false,
                        width: '5%'
                    },
                    {
                        text: this.$t('closedBy_ClosedTime'),
                        value: 'closed_by',
                        $value: item => this.genClosedByClosedTime(item),
                        sortable: false,
                        width: '10%'
                    },
                    {
                        text: this.$t('ticketCsmId'),
                        $value: item => item.ticket_csm_id || '',
                        sortable: false,
                        width: '10%'
                    },
                    {
                        text: this.$t('lastUpdatedTime'),
                        $value: item => item.last_updated_time ? this.dateFormat(item.last_updated_time) : '',
                        sortable: false,
                        width: '10%'
                    },
                    {
                        text: this.$t('action'),
                        value: 'action',
                        sortable: false,
                        width: '5%'
                    }
                ],
                showDialogTicketChangeStatus: false,
                ticketClassification: '',
                workingTicket: null,
            }
        },
        computed: {
            ...mapState(['notifyBotChat', 'botStaffList',  'user']),
            dataTableSort() {
                let clone = []
                if (this.dataTable.length) {
                    clone = [...this.dataTable]
                    clone = clone.map((items, index) => ({...items, index: index + 1}))
                } else {
                    return []
                }
                if (this.pagination.sortBy) {
                    let header = _.find(this.headers, item => item.value === this.pagination.sortBy)
                    return _.orderBy(
                        clone,
                        item => header.$value ? header.$value(item) : item[header.value],
                        this.pagination.descending ? 'desc' : 'asc'
                    )
                }
                return clone
            },
        },
        async mounted() {
            this.initBotStaffList()
            
            // if(this.hasPermission()){
                this.loadingDialog = true
                BotService.getAllBot().then(
                    result => {
                        this.botList = result.data;
                        let botCode = this.$route.params.botCode
                        if (botCode) {
                            let bot = _.find(this.botList, bot => bot.code === botCode)
                            if (bot) {
                                this.selectBot(bot)
                            } else {
                                this.loadingDialog = false
                                this.$router.push('/session-info')
                            }
                        } else if (this.botList.length > 0) {
                            this.selectBot(this.botList[0])
                        } else {
                            this.loadingDialog = false
                        }
                    },
                ).catch(()=>{
                    this.$AppService.handleRequestError('can not get bot list')
                });
            // }
            // else{
            //     this.$router.push('/forbidden')
            // }
        },
        methods: {
            hasPermission(){
                return StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9, 5]);
            },
            initBotStaffList() {
                if (this.botStaffList.length < 1) {
                    this.$store.dispatch(this.$ActionTypes.GET_BOT_STAFF);
                }
            },
            async getData() {
                this.loadingDialog = false
                if (this.activeBot.code) {
                    await ReportService.TicketReportStatus(this.activeBot.code)
                        .then((res)=> {
                            this.is_lock_report = res.data['is_lock']
                        })
                        .catch(e=>{
                            this.$AppService.handleRequestError('Get lock report status failed')
                        });
                    ReportService.Ticket(this.activeBot.code, this.tktStatus, this.keyword,this.toISOString(this.fromDate, true), this.toISOString(this.toDate), this.pagination.page, this.pagination.rowsPerPage)
                        .then(result => {
                            this.dataTable = result['data']['results'];
                            this.loadingDialog = false;
                            this.total_reports = result.data.count;
                        }, ()=> {
                            this.$AppService.handleRequestError('Can not get ticket data')
                            this.loadingDialog = false
                        })
                }
            },
            async exportExcel() {
                ReportService.TicketReportExcel(this.activeBot.code, this.tktStatus, this.keyword,this.toISOString(this.fromDate, true), this.toISOString(this.toDate))
                    .then(() => {
                        this.$AppService.toastSuccess("The report information version is being processed, you will receive report notification via email after a few minutes.");
                        this.is_lock_report = true
                    }).catch(()=> {
                    this.$AppService.toastError("Ticket Report Failed");
                });
            },
            toISOString(date, startOfDay) {
                return startOfDay ? moment(date).startOf('day').toISOString() : moment(date).endOf('day').toISOString()
            },
            dateFormat(date) {
                return moment(date).format('DD-MM-YYYY HH:mm')
            },
            changeBot(bot) {
                this.$store.commit(ActionTypes.BOT, bot)
                this.$router.push('/ticket-management/' + bot.code)
            },
            selectBot(bot) {
                this.activeBot = bot;
                this.getData()
            },
            changeSort(headerValue) {
                let pagination = {...this.pagination}
                if (pagination.sortBy === headerValue) {
                    pagination.descending = !this.pagination.descending
                } else {
                    pagination.sortBy = headerValue
                    pagination.descending = true
                }
                this.pagination = pagination
                setTimeout(() => {
                    this.$forceUpdate()
                }, 2000)
            },
            closeTicket(ticket, idx) {
                let tktId = ticket._id;
                BotService.closeTicket(this.activeBot.code, tktId)
                    .then(resp => {
                            let newTkt = resp.data;
                            this.$set(this.dataTable, idx - 1, newTkt);
                            this.$AppService.toastSuccess("Ticket is closed");
                        },
                    ).catch(()=> {this.$AppService.toastError("Close ticket failed")})
            },
            openFormChangeTicketStatus(ticket) {
                this.ticketClassification = '';
                this.workingTicket = ticket;
                this.showDialogTicketChangeStatus = true;
            },
            retrySendRequestTicket(ticket) {
                this.loadingDialog = true;
                BotService.changeTicketStatus(this.activeBot.code, ticket._id, '2')
                    .then(resp => {
                        this.$AppService.toastSuccess(this.$t("ticketCsmSubmitSuccess"));
                    }).catch(()=> {
                        this.$AppService.toastError(this.$t("ticketCsmSubmitFailed"));
                        this.loadingDialog = false;
                    }).finally(()=> {
                        this.closeTicketDialog();
                        this.getData();
                        this.loadingDialog = false;
                    });
            },
            closeTicketDialog() {
                this.workingTicket = null;
                this.showDialogTicketChangeStatus = false;
                this.ticketClassification = '';
            },
            async submitChangeTicketStatus() {
                this.loadingDialog = true;
                BotService.changeTicketStatus(this.activeBot.code, this.workingTicket._id, this.ticketClassification)
                    .then(resp => {
                        this.$AppService.toastSuccess(this.$t("Submit request success"));
                    }).catch(()=> {
                        this.$AppService.toastError("Submit request failed");
                        this.loadingDialog = false;
                    }).finally(()=> {
                        this.closeTicketDialog();
                        this.getData();
                        this.loadingDialog = false;
                    });
            },
            genTicketStatusText(status) {
                switch (status) {
                    case '0':
                        return this.$t('ticketStatus.opening')
                    case '1':
                        return this.$t('ticketStatus.closed')
                    case '2':
                        return this.$t('ticketStatus.inProgress')
                    case '3':
                        return this.$t('ticketStatus.done')
                    case '4':
                    case '5':
                        return this.$t('ticketStatus.waiting')
                    default:
                        return ''
                }
            },
            genClosedByClosedTime(ticket) {
                let result = ''

                if (ticket.status === '1' || ticket.status === '3') {
                    result = `${ticket.closed_by.email} \n${this.dateFormat(ticket.updated_time)}`
                }

                if(ticket.status === '3' && ticket.closed_by.id !== 0) {
                    result += `\n\n${this.$t('ticketStatus.expiredTicket')}`
                }
                return result
            },
            check_ticket_allow_to_close(ticket) {
                // console.log('check_ticket_allow_to_close -', ticket)
                let allow = true
                // console.log(this.$route.params.botCode)
                // console.log(this.user)
                let isLeader = StaffService.checkStaffHasRole(this.$route.params.botCode, this.user.id, [10, 9, 5]);
                // console.log(isLeader)
                // if user is not leader
                if (!isLeader) {
                    allow = false
                }
                // if status is not in-progress or waiting
                if (ticket.status != 2 && ticket.status != 4 && ticket.status != 5) {
                    // console.log('ticket not in progress or waiting')
                    allow = false
                }
                // if ticket updated time is less than 10 days
                if (moment().diff(moment(ticket.created_time), 'days') < 10) {
                    // console.log('ticket created less than 1 day')
                    allow = false
                }
                return allow
            }
        },
        watch: {
            interval(val) {
                let get_statistic = false
                switch (val) {
                    case '7days' :
                        this.fromDate = moment().subtract(6, 'day').format('YYYY-MM-DD')
                        this.toDate = this.today
                        get_statistic = true
                        break
                    case '30days':
                        this.fromDate = moment().subtract(29, 'day').format('YYYY-MM-DD')
                        this.toDate = this.today
                        get_statistic = true
                        break
                    default:
                        break
                }
                if (get_statistic) {
                    this.getData()
                }

            },
            pagination: {
                handler() {
                    this.getData()
                }
            },
            '$route'() {
                let botCode = this.$route.params.botCode
                if (botCode) {
                    let bot = _.find(this.botList, bot => bot.code === botCode)
                    if (bot) {
                        this.selectBot(bot)
                    }
                }
            },
            notifyBotChat(val) {
                if (val.type === this.$const.SOCKETCLUSTER_NOTI_DATA_TYPE.TICKET_REPORT_STATUS) {
                    if (val.data.is_success) {
                        this.$AppService.toastSuccess("Excels report success. Please check email")
                    }
                    else {
                        this.$AppService.handleRequestError("Excels report failed. Please contact administrator")
                    }
                    this.is_lock_report = false
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../components/style/variables.scss";
    .header {
        background: #2a4e69;
        color: #fff;
        padding: 0 15px;
    }
    .break-word {
        white-space: break-spaces;
        overflow-wrap: break-word;
        word-break: break-word;
    }
    td { white-space:pre }
    ::v-deep table.v-table {
        thead th {
            padding: 12px 0 12px 12px;
        }

        tbody tr td {
            white-space: nowrap;
            padding: 12px 0 12px 12px;
        }
    }
    ::v-deep .v-btn__content {
        text-transform: none;
    }
    ::v-deep .v-btn--small {
        font-size: 13px !important;
    }
    .header-tooltips {
        width: 240px;
        background: #1b3447;
        color: #fff;
        padding: 5px;

        &::v-deep hr {
            border-color: #2a4b64;
        }
    }
    ::v-deep .status-closed {
        cursor: none;
    }
    .info-icon {
        font-size: 16px;
        color: rgba(0, 0, 0, 0.54);;
        caret-color: rgb(73, 119, 238);
    }

    .tooltips-info {
        div:first-child {
            color: #00afc8;
        }
    }

    ::v-deep .v-list .active {
        background: #ccc;
    }

    .chat_view_loading {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        z-index: 99999;
        align-items: center;
        text-align: center;
        padding-top: 27%;

        .loading_overlay {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            background-color: black;
            opacity: 0.2;
        }
    }

    .fti-dialog-header {
        display: flex;
        align-items: center;
        background: #0052CC;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        height: 40px;
    }
</style>
